import { can, useMe } from "../auth/session";
import { WorkspaceHomePage } from "../pages/WorkspaceHomePage";
import { MyTicketsPage } from "./MyTicketsPage";

/**
 * One Tickets page. Staff get the work queues with their own tickets as one more tab
 * ("Raised by me"); everyone else gets just their own tickets.
 */
export function TicketsPage() {
  const me = useMe();
  return can(me, "use_workspace") ? <WorkspaceHomePage /> : <MyTicketsPage />;
}
